'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import { navCssClassNames } from './navCssClassNames';
const BaseElement = ({ className, ...props }) => (_jsx("li", { className: clsx(className, navCssClassNames.item), ...props }));
export const NavItem = styled(BaseElement) `
    display: block;
    margin: 0;
    padding: 0;
`;
